import { Variant } from '~/@types/product'

import VariantsFashion from '~/components/UI/VariantsFashion'
import VariantsFragrance from '~/components/UI/VariantsFragrance'

import {
  getIsProductFashion,
  getIsProductFragrance,
  getIsProductSet,
} from '~/utils/get-shopify-product-type'

export interface ProductVariantsProps {
  type: string
  className?: string
  active?: Variant
  variants?: Variant[]
  isGiftCard?: boolean
}

function ProductVariants({
  className,
  type,
  variants,
  isGiftCard = false,
  ...props
}: ProductVariantsProps) {
  /* If Gift card type or Fashion type add the variants squared buttons */
  if (isGiftCard || getIsProductFragrance(type)) {
    return (
      <VariantsFragrance className={className} variants={variants} {...props} />
    )
  }

  /* If Fashion type add the variants select */
  if (getIsProductFashion(type) || getIsProductSet(type)) {
    return (
      <VariantsFashion className={className} variants={variants} {...props} />
    )
  }

  return null
}

export default ProductVariants
